import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../http-client.service';
import { DeliveryOrderReassignRequest } from '@core/models/delivery/delivery-order-reassign-request';

@Injectable()
export class DispatchDataService extends HttpClientService {
  
    private urls = {
        dispatch: '/dispatch',
        dispatchConfig: '/dispatch/config/:locationId',
        dispatchDriverConfig: '/dispatch/driver/config',
        dispatchDriverStatus: '/dispatch/driver/status',
        dispatchGroupTracking: '/dispatch/tracking/group/:groupId',
        dispatchOrder: '/dispatch/order/:orderId',
        dispatchOrderReassign: '/dispatch/order/:orderId/reassign'
    }

    fetchDispatchConfig(locationId: string): Observable<any> {
        return this.get(
            this.urls.dispatchConfig.replace(':locationId', locationId)
        );
    }

    fetchDispatchGroupTracking(groupId: string): Observable<any> {
        return this.get(
            this.urls.dispatchGroupTracking.replace(':groupId', groupId)
        );
    }

    fetchOrder(orderId: string): Observable<any> {
        return this.get(this.urls.dispatchOrder.replace(':orderId', orderId));
    }

    reassignOrder(
        orderId: string,
        request: DeliveryOrderReassignRequest
    ): Observable<any> {
        return this.put(
            this.urls.dispatchOrderReassign.replace(':orderId', orderId),
            request
        );
    }

    createDispatchConfig(locationId: string, dto): Observable<any> {
        return this.post(
            this.urls.dispatchConfig.replace(':locationId', locationId),
            dto
        );
    }

    updateDispatchConfig(locationId: string, dto): Observable<any> {
        return this.put(
            this.urls.dispatchConfig.replace(':locationId', locationId),
            dto
        );
    }
}